import { Component, inject, OnDestroy } from '@angular/core';
import { default as pack } from '../../package.json';
import { SessionManager } from 'experian-authentication-frontend-components';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnDestroy {

  public packageVersion = pack.version;

  private readonly KEY_LOCAL_STORGE_CURR_USER = 'fullNameCurrentUser';
  private readonly sessionManager = inject(SessionManager);
  private readonly router = inject(Router);
  private destroy$ = new Subject<void>();

  constructor() {
    this.sessionManager.logIn$.subscribe((loginData: any) => {
      const userFullName = this.sessionManager.currentUser$?.value?.fullName;

      if (userFullName) {
        localStorage.setItem(this.KEY_LOCAL_STORGE_CURR_USER, userFullName);
      } else {
        localStorage.setItem(this.KEY_LOCAL_STORGE_CURR_USER, this.sessionManager.currentUser$?.value?.logon);
      }

      if (loginData) {
        this.router.navigate(['']);
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
